<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      products: null,

      choose: {
        modal: false,
        loading: false,
        id: "",
        name: "",
        description: "",
        licenses: "",
        price: "",
        discount: "",
        total: "",
      },

      coupon: {
        code: "",
        type: "",
        value: "",
      },
    };
  },
  methods: {
    getProducts() {
      this.products = null;

      api
        .get('saas/products')
        .then((response) => {
          if (response.data.status == 'success') {
            this.products = response.data.list;
          } else {
            this.products = [];
          }
        })
        .catch((error) => {
          if (error) {
            this.products = [];
          }
        });
    },
    showChoose(product) {
      this.choose.modal = false;
      this.choose.modal = true;
      this.choose.id = product.id;
      this.choose.name = product.name;
      this.choose.description = product.description;
      this.choose.price = product.price;
      this.choose.discount = 0;
      this.choose.total = 0;
      this.coupon.code = "";
      this.coupon.type = "";
      this.coupon.value = "";
    },
    choosePackage() {
      if (this.choose.id) {
        this.choose.loading = true;

        api
          .post('saas/products', {
            id: this.choose.id,
            coupon: this.coupon.code,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.choose.modal = false;
              this.choose.loading = false;
              this.$router.push('/saas/order/' + response.data.order.id);
            } else {
              this.choose.loading = false;
              this.$toast.error(response.data.message);
            }
          })
          .catch((error) => {
            if (error) {
              this.choose.modal = false;
              this.choose.loading = false;
            }
          })
          .finally(() => {
            this.choose.modal = false;
            this.choose.loading = false;
          });
      }
    },
    applyCoupon() {
      api
        .post('saas/coupons', {
          code: this.coupon.code,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.coupon.type = response.data.coupon.type;
            this.coupon.value = response.data.coupon.value;

            if (this.coupon.type == '%') {
              this.choose.discount = this.choose.price * this.coupon.value / 100;
              this.choose.total = this.choose.price - this.choose.discount;
            } else if (this.coupon.type == '$') {
              this.choose.discount = this.coupon.value;
              this.choose.total = this.choose.price - this.choose.discount;
            }

            if (this.choose.total < 0) {
              this.choose.total = 0;
            }

            this.$toast.success('O cupom de desconto foi aplicado com sucesso.');
          } else {
            this.$toast.error(response.data.message);
          }
        })
    },
  },
  mounted() {
    this.getProducts()
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Produtos</li>
      <li class="breadcrumb-item d-none d-sm-block">Comprar</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Comprar</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!products" class="text-center">
      <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
    </div>
    <div v-else-if="products && products.length > 0">
      <div class="row">
        <div class="col-lg-4" v-for="(row, index) in products" :key="index">
          <div class="card" :class="row.status == 'blocked' ? 'package-disabled' : ''">
            <div class="card-body text-center">
              <img v-if="row.cover" :src="row.cover" class="img-fluid mb-3" style="width: 100%; max-height: 300px; object-fit: cover;" />
              <h4 class="mb-0">{{ row.name }}</h4>
              <div class="mb-1" v-html="row.description"></div>
              <h4 class="mb-2">{{ row.price | currency }}</h4>
              <button class="btn btn-default btn-block btn-lg text-uppercase" v-on:click="showChoose(row)">
                Escolher
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      Nenhum produto disponível no momento.
    </div>

    <b-modal v-model="choose.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Confirmar escolha</h4>
        <p>Confirma a escolha do produto <strong>{{ choose.name }}</strong>?</p>
        <template v-if="choose.discount > 0">
          <h5 class="mb-0 text-muted"><s>{{ choose.price | currency }}</s></h5>
          <h4 class="mb-0">{{ choose.total | currency }}</h4>
        </template>
        <template v-else>
          <h4 class="mb-0">{{ choose.price | currency }}</h4>
        </template>
        <div class="my-4">
          <b-input-group>
            <b-form-input v-model="coupon.code" type="text" placeholder="Possui um cupom de desconto?"></b-form-input>
            <button type="button" style="border-top-left-radius: 0; border-bottom-left-radius: 0;" class="btn btn-default" v-on:click="applyCoupon()">Aplicar</button>
          </b-input-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" v-on:click="choosePackage()" :disabled="this.choose.loading">
            Confirmar
            <b-spinner v-if="choose.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="choose.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>